import { SVGProps } from 'react';

const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M17.707 5.121a1 1 0 0 0-1.414 0L15.414 6 18 8.586l.879-.879a1 1 0 0 0 0-1.414L17.707 5.12Zm2.586 4a3 3 0 0 0 0-4.242L19.12 3.707a3 3 0 0 0-4.242 0L3 15.586V21h5.414L20.293 9.121ZM16.586 10 14 7.414l-9 9V19h2.586l9-9Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgEdit;
